const validRoles = ['vendedor', 'comprador'];

const sameId = (left, right) => String(left) === String(right);
const reviewedItemsFor = (items, section, partyId) =>
  items.filter(
    item => item.section === section && sameId(item.target_key, partyId)
  );
const corrected = items =>
  items.length > 0 &&
  items.every(item => item.status === 'corrigido' || item.saved === true);
const reviewCard = (party, items, section, subtitle = '', kind = '') => ({
  party,
  items,
  section,
  subtitle,
  kind,
  completed: corrected(items),
  representative: party.relation_type === 'representante',
});

export const isSalesReviewPartyRole = role => validRoles.includes(role);

export const salesReviewPartyGroups = (
  participants = [],
  items = [],
  role = ''
) => {
  if (!isSalesReviewPartyRole(role)) {
    return { companies: [], people: [] };
  }

  const roleParticipants = participants.filter(party => party.role === role);
  const physicalSection = `${role}_pf`;
  const legalSection = `${role}_pj`;
  const people = roleParticipants
    .filter(
      party =>
        party.kind === 'pessoa_fisica' &&
        party.relation_type !== 'representante'
    )
    .map(party => {
      const partyItems = reviewedItemsFor(items, physicalSection, party.id);
      return partyItems.length
        ? reviewCard(party, partyItems, physicalSection)
        : null;
    })
    .filter(Boolean);
  const companies = roleParticipants
    .filter(
      party =>
        party.kind === 'pessoa_juridica' &&
        party.relation_type !== 'representante'
    )
    .map(company => {
      const companyItems = reviewedItemsFor(items, legalSection, company.id);
      const representatives = roleParticipants
        .filter(
          party =>
            party.relation_type === 'representante' &&
            sameId(party.parent_party_id, company.id)
        )
        .map(representative => {
          const partyItems = items.filter(
            item =>
              [physicalSection, legalSection].includes(item.section) &&
              sameId(item.target_key, representative.id)
          );
          return partyItems.length
            ? reviewCard(
                representative,
                partyItems,
                partyItems[0].section,
                company.name,
                'pj'
              )
            : null;
        })
        .filter(Boolean);

      return companyItems.length || representatives.length
        ? {
            card: companyItems.length
              ? reviewCard(company, companyItems, legalSection)
              : null,
            company,
            representatives,
          }
        : null;
    })
    .filter(Boolean);

  return { companies, people };
};

export const salesReviewPartyCount = groups =>
  groups.people.length +
  groups.companies.reduce(
    (count, company) =>
      count + Number(Boolean(company.card)) + company.representatives.length,
    0
  );
